import { Injectable } from '@angular/core';
import { ApiResponse } from '../../models/common.model';
import { BehaviorSubject, distinctUntilChanged, filter, map, take } from 'rxjs';
import { CustomerService } from '../customer.service';
import { select, Store } from '@ngrx/store';
import { selectUser } from '../../states/user-details';
import { User } from '../../models/user.model';
import { AppState } from '../../states/app.state';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  //****** Info ******
  //For Level ---> role this.role?.level?.includes('MEMBER_PROFILE_AVATAR')
  //For User  ---> role this.role?.users.includes('MEMBER_PROFILE_AVATAR')
  //For Role Permission  ---> role this.permissions["MEMBER_PROFILE_AVATAR"].includes('MEMBER_PROFILE_AVATAR')

  public roles: {
    level: Array<string>;
    users: Array<string>;
    permissions: {};
    userType: Array<string>;
  } = null; //For HTML Pages

  public rolesSubject: BehaviorSubject<{
    level: Array<string>;
    users: Array<string>;
    permissions: {};
    userType: Array<string>;
  }> = new BehaviorSubject<any>(null); //For TS Pages

  constructor(
    private customerService: CustomerService,
    private store: Store<AppState>
  ) {
    this.store
      .pipe(
        select(selectUser),
        filter((user) => !!user),
        distinctUntilChanged(
          (prev, curr) =>
            prev.level === curr.level && prev.isVerified === curr.isVerified
        ) // Compare previous and current values
      )
      .subscribe((resp) => {
        this.getUserRoles(resp.level, resp.isVerified);
      });
  }

  public getUserRoles(level: any, isVerified: any) {
    this.customerService.getRolesForMember().subscribe(
      (resp: ApiResponse) => {
        let userLevel = level || 0;
        let isUserVerified = isVerified == true;
        let roleList: any = {
          level: [],
          users: [],
          permissions: {},
          userType: [],
        };
        // roleList.info = resp?.body;
        for (let i of resp.body.level) {
          // Roles of member level will will only come
          if (userLevel && i.levelID == userLevel && isUserVerified) {
            if (i.Roles && i.Roles.length > 0)
              for (let r of i.Roles) {
                if (!roleList.level.includes(r.roleName)) {
                  roleList.level.push(r.roleName);
                }
              }
          }
        }

        let roles = [];
        if (resp.body.user && resp.body.user[0]) {
          for (let r of resp.body.user[0].memberUserTypes) {
            for (let data of r.userType.roleUserTypes) {
              roleList.permissions[data?.role?.roleName] =
                data?.role?.Permissions.map((i) => i.permissionsName);
              roles.push(data?.role?.roleName);
              roleList.userType.indexOf(r.userType.userTypeName) == -1
                ? roleList.userType.push(r.userType.userTypeName)
                : '';
            }
          }
          roleList.users = roles;
        }

        this.roles = roleList;
        this.rolesSubject.next(roleList);
      },
      () => {
        // this.toaster.error("Error For Roles!");
      }
    );
  }
}
